(function () {
  var bodyOpenClass = 'withdrawal-modal-is-open';
  var initializedAttribute = 'data-withdrawal-initialized';
  var menuHash = '#widerruf';
  var emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

  function getFocusableElements(container) {
    return Array.prototype.slice.call(
      container.querySelectorAll(
        'a[href], button:not([disabled]), textarea:not([disabled]), input:not([disabled]), select:not([disabled]), [tabindex]:not([tabindex="-1"])'
      )
    ).filter(function (element) {
      return element.offsetParent !== null;
    });
  }

  function setError(field, errorElement, message) {
    if (!field || !errorElement) {
      return;
    }

    if (message) {
      field.setAttribute('aria-invalid', 'true');
      errorElement.textContent = message;
      errorElement.hidden = false;
    } else {
      field.removeAttribute('aria-invalid');
      errorElement.textContent = '';
      errorElement.hidden = true;
    }
  }

  function initWithdrawalSection(section) {
    if (!section || section.hasAttribute(initializedAttribute)) {
      return;
    }

    section.setAttribute(initializedAttribute, 'true');

    var openButton = section.querySelector('[data-withdrawal-open]');
    var modal = section.querySelector('[data-withdrawal-modal]');
    var panel = modal ? modal.querySelector('.withdrawal-modal__panel') : null;
    var closeButtons = modal ? modal.querySelectorAll('[data-withdrawal-close]') : [];
    var form = section.querySelector('form.withdrawal-form');
    var previouslyFocusedElement = null;

    if (!openButton || !modal || !panel || !form) {
      return;
    }

    var fields = {
      name: form.querySelector('[data-withdrawal-name]'),
      email: form.querySelector('[data-withdrawal-email]'),
      order: form.querySelector('[data-withdrawal-order]'),
      statement: form.querySelector('[data-withdrawal-statement]')
    };

    var errors = {
      name: form.querySelector('[data-error-for="name"]'),
      email: form.querySelector('[data-error-for="email"]'),
      order: form.querySelector('[data-error-for="order"]'),
      statement: form.querySelector('[data-error-for="statement"]')
    };

    var messageField = form.querySelector('[data-withdrawal-message]');
    var successMessage = form.querySelector('[data-withdrawal-success]');

    form.setAttribute('novalidate', 'novalidate');

    function openModal(focusTarget) {
      previouslyFocusedElement = document.activeElement;
      modal.hidden = false;
      modal.classList.add('is-open');
      modal.setAttribute('aria-hidden', 'false');
      document.body.classList.add(bodyOpenClass);

      window.requestAnimationFrame(function () {
        if (focusTarget && typeof focusTarget.focus === 'function') {
          focusTarget.focus();
          return;
        }

        if (successMessage) {
          successMessage.focus();
          return;
        }

        panel.focus();
      });
    }

    function closeModal() {
      modal.classList.remove('is-open');
      modal.setAttribute('aria-hidden', 'true');
      modal.hidden = true;
      document.body.classList.remove(bodyOpenClass);

      if (previouslyFocusedElement && typeof previouslyFocusedElement.focus === 'function') {
        previouslyFocusedElement.focus();
      }
    }

    function clearFieldError(fieldName) {
      setError(fields[fieldName], errors[fieldName], '');
    }

    function validateForm() {
      var firstInvalidField = null;
      var name = fields.name ? fields.name.value.trim() : '';
      var email = fields.email ? fields.email.value.trim() : '';
      var order = fields.order ? fields.order.value.trim() : '';
      var statementAccepted = fields.statement ? fields.statement.checked : false;

      setError(fields.name, errors.name, '');
      setError(fields.email, errors.email, '');
      setError(fields.order, errors.order, '');
      setError(fields.statement, errors.statement, '');

      if (!name) {
        setError(fields.name, errors.name, 'Bitte gib deinen Namen ein.');
        firstInvalidField = firstInvalidField || fields.name;
      }

      if (!email) {
        setError(fields.email, errors.email, 'Bitte gib deine E-Mail-Adresse ein.');
        firstInvalidField = firstInvalidField || fields.email;
      } else if (!emailPattern.test(email)) {
        setError(fields.email, errors.email, 'Bitte gib eine gültige E-Mail-Adresse ein.');
        firstInvalidField = firstInvalidField || fields.email;
      }

      if (!order) {
        setError(fields.order, errors.order, 'Bitte gib deine Bestellnummer ein.');
        firstInvalidField = firstInvalidField || fields.order;
      }

      if (!statementAccepted) {
        setError(fields.statement, errors.statement, 'Bitte bestätige die Widerrufserklärung.');
        firstInvalidField = firstInvalidField || fields.statement;
      }

      return {
        isValid: !firstInvalidField,
        firstInvalidField: firstInvalidField,
        values: {
          name: name,
          email: email,
          order: order,
          statementAccepted: statementAccepted
        }
      };
    }

    function updateMessageField(values) {
      if (!messageField) {
        return;
      }

      var submittedAt = new Date();
      var readableTime = submittedAt.toLocaleString('de-DE', {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit'
      });

      messageField.value = [
        'Online-Widerrufserklärung',
        '',
        'Name: ' + values.name,
        'E-Mail: ' + values.email,
        'Bestellnummer: ' + values.order,
        'Widerrufserklärung bestätigt: ' + (values.statementAccepted ? 'Ja' : 'Nein'),
        'Zeitpunkt der Absendung (Browser): ' + readableTime,
        'Zeitpunkt ISO: ' + submittedAt.toISOString(),
        'Seite: ' + window.location.href
      ].join('\n');
    }

    openButton.addEventListener('click', function () {
      openModal();
    });

    Array.prototype.forEach.call(closeButtons, function (button) {
      button.addEventListener('click', closeModal);
    });

    modal.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') {
        event.preventDefault();
        closeModal();
        return;
      }

      if (event.key !== 'Tab') {
        return;
      }

      var focusableElements = getFocusableElements(panel);
      if (!focusableElements.length) {
        event.preventDefault();
        panel.focus();
        return;
      }

      var firstElement = focusableElements[0];
      var lastElement = focusableElements[focusableElements.length - 1];

      if (event.shiftKey && document.activeElement === firstElement) {
        event.preventDefault();
        lastElement.focus();
      } else if (!event.shiftKey && document.activeElement === lastElement) {
        event.preventDefault();
        firstElement.focus();
      }
    });

    form.addEventListener('submit', function (event) {
      var result = validateForm();

      if (!result.isValid) {
        event.preventDefault();
        if (result.firstInvalidField && typeof result.firstInvalidField.focus === 'function') {
          result.firstInvalidField.focus();
        }
        return;
      }

      updateMessageField(result.values);
    });

    Object.keys(fields).forEach(function (fieldName) {
      var field = fields[fieldName];
      if (!field) {
        return;
      }

      var eventName = field.type === 'checkbox' ? 'change' : 'input';
      field.addEventListener(eventName, function () {
        clearFieldError(fieldName);
      });
    });

    if (window.location.hash === '#' + form.id || successMessage || form.querySelector('.errors')) {
      openModal(successMessage || panel);
    }

    if (window.location.hash === menuHash) {
      openModal(panel);
    }
  }

  function getFirstWithdrawalSection() {
    return document.querySelector('[data-withdrawal-section]');
  }

  function initAllWithdrawalSections() {
    document.querySelectorAll('[data-withdrawal-section]').forEach(initWithdrawalSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAllWithdrawalSections);
  } else {
    initAllWithdrawalSections();
  }

  document.addEventListener('shopify:section:load', function (event) {
    initWithdrawalSection(event.target);
  });

  document.addEventListener('click', function (event) {
    var link = event.target.closest ? event.target.closest('a[href]') : null;
    var section = getFirstWithdrawalSection();
    var openButton = section ? section.querySelector('[data-withdrawal-open]') : null;

    if (!link || !openButton) {
      return;
    }

    var href = link.getAttribute('href');
    if (href === menuHash || href === '/' + menuHash || href === window.location.origin + '/' + menuHash) {
      event.preventDefault();
      if (window.history && window.history.pushState) {
        window.history.pushState(null, '', menuHash);
      }
      openButton.click();
    }
  });
})();
